import React, { ReactElement } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames/bind';

import { linksData } from 'components/Footer/Footer.data';
import { LinksGroup } from 'components/Footer/Footer.types';

import { LinksList } from 'components/Footer/LinksList';

import styles from 'components/Footer/Footer.module.scss';

const cn = classNames.bind(styles);

const Footer = (): ReactElement => {
  const links = (linksData as LinksGroup[]).map((linksGroup) => {
    return (
      <LinksList
        key={linksGroup.groupId}
        linksGroup={linksGroup}
      />
    );
  });

  return (
    <footer className={cn('footer')}>
      <div className={cn('container')}>

        <div className={cn('footer__container')}>

          <div className={cn('footer__logo-container')}>
            <Link className={cn('footer__logo-link')} href="/">
              <Image
                width={149}
                height={29}
                src="/images/global/logo-dfa-light.svg"
                alt="df-alliance logo"
              />
            </Link>

            <div className={cn('footer__social-container')}>
              <Link
                className={cn('footer__social-link')}
                href="https://www.facebook.com/DigitalFreightAlliance_DPWorld"
              >
                <Image
                  width={20}
                  height={20}
                  src="/images/global/social/icon-facebook.svg"
                  alt="facebook"
                />
              </Link>
              <Link
                className={cn('footer__social-link')}
                href="https://x.com/D_F_Alliance"
              >
                <Image
                  width={22}
                  height={22}
                  src="/images/global/social/icon-twitter.svg"
                  alt="twitter"
                />
              </Link>
              <Link
                className={cn('footer__social-link')}
                href="https://www.linkedin.com/company/digital-freight-alliance"
              >
                <Image
                  width={24}
                  height={24}
                  src="/images/global/social/icon-linkedin.svg"
                  alt="linkedin"
                />
              </Link>
            </div>
          </div>

          <div className={cn('footer__links-container')}>{links}</div>
        </div>

        <div className={cn('copyrights')}>2023 © DF Alliance. All rights reserved.</div>

      </div>
    </footer>
  );
};

export default Footer;
